import { useState } from 'react'
import styled from 'styled-components'
import { CFlex, DText, Flex } from '../../../../styles/CommonStyles'
import { SOCKET_URL } from '../../../../core/constants/urls'
import Text from '../../../../core/utils/Text'
import { FaTrash } from 'react-icons/fa'
import ModalLayout from '../../../layout/main/ModalLayout'
import BasicModal from '../../../modals/BasicModal'
import { useSetFixerSettings } from '../../../../core/services/react-query/setting/fixer'

const FixerSettingsList = ({ fixerSettings }) => {

    const [deleteModal, setDeleteModal] = useState({
        currencyId: null,
        open: false
    })

    const onCloseDeleteModal = () =>
        setDeleteModal({ currencyId: null, open: false })

    const { mutate, isLoading } = useSetFixerSettings(onCloseDeleteModal)

    const onDeleteCoin = () => {
        const newList = fixerSettings?.filter(
            item => item.currency !== deleteModal.currencyId
        )
        mutate(newList)
    }

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 border-t py-5">

            <div className="col-span-1 sm:col-span-2 lg:col-span-3">
                <DText main>
                    <Text tid="fixer-list" />
                </DText>
            </div>

            {fixerSettings?.map((item, idx) => (
                <Wrapper key={item.currency}>
                    <CFlex fw align="start" style={{ gap: 10 }}>
                        <Flex fw justify="space-between" align="center" style={{ gap: 10 }}>
                            {/* Left */}
                            <Flex align="center" style={{ gap: 10 }}>
                                <img
                                    src={
                                        item.currency === 'irt'
                                            ? require('../../../../assets/images/tooman.png')
                                            : SOCKET_URL + `assets/icon/${item.currency}.png`
                                    }
                                    alt=" "
                                    width="28px"
                                />

                                <DText main>
                                    {item.currency.toUpperCase()}
                                </DText>
                            </Flex>
                            {/* Status */}
                            <StatusBadge active={item.isActive}>
                                {item.isActive ? 'Active' : 'Inactive'}
                            </StatusBadge>
                        </Flex>
                        {/* Middle */}
                        <CFlex align="flex-start" style={{ gap: 4 }}>
                            <SmallText>
                                <DText main>
                                    <Text tid="fee-buy" />: {item.feeFactorBuy}
                                </DText>
                            </SmallText>
                            <SmallText>
                                <DText main>
                                    <Text tid="fee-sell" />: {item.feeFactorSell}
                                </DText>
                            </SmallText>
                        </CFlex>
                    </CFlex>
                    {/* Delete */}
                    <button
                        onClick={() =>
                            setDeleteModal({
                                currencyId: item.currency,
                                open: true
                            })
                        }
                        className="hover:opacity-70 absolute bottom-5 left-5"
                    >
                        <FaTrash color="#c33" />
                    </button>
                </Wrapper>
            ))}

            <ModalLayout
                open={deleteModal.open}
                onClose={onCloseDeleteModal}
                width="500px"
            >
                <BasicModal
                    onClose={onCloseDeleteModal}
                    onSubmit={onDeleteCoin}
                    loading={isLoading}
                />
            </ModalLayout>
        </div>
    )
}

const Wrapper = styled.div`
position: relative;
  border-radius: 12px;
  background-color: ${p => p.theme.secondaryBg};
  padding: 12px 16px;
`

const SmallText = styled.div`
  font-size: 12px;
  opacity: 0.85;
`

const StatusBadge = styled.div`
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  color: ${({ active }) => (active ? '#0a0' : '#999')};
  background-color: ${({ active }) =>
        active ? 'rgba(0,170,0,0.1)' : 'rgba(150,150,150,0.1)'};
`

export default FixerSettingsList
